import { App } from 'vue'
import vAlignDirective from './src/align.ts'

export { vAlignDirective as vAlign }

export default {
	install: (app: App) => {
		app.directive('align', vAlignDirective)
	},
}
